import { observer } from 'mobx-react';
import * as React from 'react';
import { cache } from 'tm3-core/cache';
import DictionaryStore, { DictionaryStoreContext } from './dictionary-store';

interface IProps extends React.PropsWithChildren {
  appLocation?: string;
}

type Location = 'aus' | 'can' | 'gbr' | 'eur' | 'gcc';

export const DictionaryStoreProvider = observer<React.FC<IProps>>(({ children, appLocation }) => {
  const location = (appLocation?.toLowerCase() ?? cache.config.LOCATION) as Location;

  const [store] = React.useState(() => {
    const store = new DictionaryStore(location);
    store.load();
    return store;
  });

  return (
    <DictionaryStoreContext.Provider value={store}>{children}</DictionaryStoreContext.Provider>
  );
});
